// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.trans-container {
  width: calc(100% - 40px);
  height: calc(100% - 50px);
  padding: 20px;
  margin-top: 50px;
}
.trans-box {
  height: calc(100% - 40px);
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: 7px;
}
.original-text,
.trans-text {
  overflow-y: scroll;
  height: calc(100% - 40px);
  margin: 5px;
  margin-top: 35px;
  word-break: break-word;
  overflow-wrap: break-word;
}
.original-text-box,
.trans-text-box {
  width: 100%;
  height: 100%;
  opacity: 1;
  -webkit-user-select: text;
          user-select: text;

  padding: 5px;
  box-sizing: border-box;
  font-size: 15px;
  line-height: 18px;
  /* position: relative; */
}
.trans-lang-selector-container {
  width: calc(100% - 40px);
  height: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
  position: absolute;
  top: 67px;
}
.trans-lang-box,
.original-lang-box {
  width: calc(50%);
  height: 100%;
  padding-left: 7px;
  box-sizing: border-box;
}
.original-text-box {
  /* margin-right: 10px; */
  border: 1px solid rgba(0, 0, 0, 0.05);
  border-right: none;
  border-bottom-left-radius: 7px;
  border-top-left-radius: 7px;
}
.trans-text-box {
  background-color: rgba(75, 75, 75, 0.05);
  border-bottom-right-radius: 7px;
  border-top-right-radius: 7px;
}
.trans-lang-selector,
.original-lang-selector {
  height: 30px;
  opacity: 1;
  box-sizing: border-box;
  font-size: 15px;
  line-height: 30px;
  cursor: pointer;
  border: none;
  background-color: transparent;
}
.trans-lang-selector {
  font-size: 15px;
  line-height: 15px;
}
.trans-service-selector {
  border: 1px solid rgba(0, 0, 0, 0.05);
  color: #f16464;
  background-color: rgba(241, 100, 100, 0.05);
  height: 34px;
  display: inline-block; /* 修改：从 float: left 改为 inline-block */
  vertical-align: top; /* 添加：对齐方式 */
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 8px;
  margin-right: 10px;
  text-align: center;
  line-height: 34px;
  cursor: pointer;
  opacity: 1;
}
.trans-icon,
.trans-google-icon,
.trans-bing-icon {
  font-size: 13px;
  margin: 2px;
  margin-right: 5px;
}
.trans-bing-icon {
  font-size: 14px;
}
.trans-service-selector-inactive {
  border: 1px solid rgba(0, 0, 0, 0.05);
  color: #f16464;
  display: inline-block; /* 修改：从 float: left 改为 inline-block */
  vertical-align: top; /* 添加：对齐方式 */
  height: 34px;
  padding-left: 10px;
  padding-right: 10px;
  border-radius: 8px;
  margin-right: 10px;
  text-align: center;
  line-height: 34px;
  cursor: pointer;
}
.trans-service-selector-container {
  position: absolute;
  top: 20px;
  width: 90%;
  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap; /* 添加：防止换行 */
  height: 42px; /* 添加：给容器一个固定高度 */
}
/* 滚动条样式 - 仅在悬停时显示 */
.trans-service-selector-container::-webkit-scrollbar {
  height: 4px; /* 滚动条高度 */
}

.trans-service-selector-container::-webkit-scrollbar-track {
  background: transparent; /* 轨道背景透明 */
}

.trans-service-selector-container::-webkit-scrollbar-thumb {
  background: transparent; /* 默认透明 */
  border-radius: 2px;
  -webkit-transition: background 0.3s ease;
  transition: background 0.3s ease;
}

.trans-service-selector-container:hover::-webkit-scrollbar-thumb {
  background: rgba(0, 0, 0, 0.2); /* 悬停时显示 */
}

.trans-service-selector-container::-webkit-scrollbar-thumb:hover {
  background: rgba(0, 0, 0, 0.4); /* 滚动条本身悬停时加深 */
}
.trans-button-container {
  position: absolute;
  bottom: 8px;
  right: 20px;
  display: flex;
  justify-content: space-between;
}
.trans-text-box {
  left: 16px;
  top: 16px;
}
.target-lang-container {
  position: absolute;
  width: calc(100% - 32px);
  display: flex;
  justify-content: space-between;
  align-items: center;
  bottom: 16px;
  left: 16px;
}
.trans-add-icon {
  font-size: 13px;
  margin: 5px;
}
.trans-add-content-box {
  width: 100%;
  height: 150px;
  opacity: 1;
  font-size: 15px;
  line-height: 18px;
  padding: 10px;
  margin-top: 10px;
  margin-bottom: 10px;
  box-sizing: border-box;
  opacity: 1;
  background-color: rgba(75, 75, 75, 0.05);
  border-radius: 7px;
  border: none;
}
.trans-add-content-box::placeholder {
  font-weight: bold;
}
.trans-add-cancel {
  min-width: 60px;
  height: 30px;
  opacity: 1;
  padding-left: 5px;
  padding-right: 5px;
  font-size: 13px;
  line-height: 30px;
  opacity: 1;
  text-align: center;
  cursor: pointer;
  border-radius: 5px;
}
.trans-add-confirm {
  min-width: 64px;
  height: 30px;
  opacity: 1;
  padding-left: 5px;
  padding-right: 5px;
  font-size: 13px;
  line-height: 30px;
  opacity: 1;
  text-align: center;
  cursor: pointer;
  border-radius: 5px;
  float: right;
  background-color: #f16464;
  color: white;
  margin-left: 5px;
}
.trans-add-button-container {
  display: flex;
  justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/components/popups/popupTrans/popupTrans.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,yBAAyB;EACzB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;AACA;;EAEE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;;EAEE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,yBAAiB;UAAjB,iBAAiB;;EAEjB,YAAY;EACZ,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,wBAAwB;AAC1B;AACA;EACE,wBAAwB;EACxB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,SAAS;AACX;AACA;;EAEE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,wBAAwB;EACxB,qCAAqC;EACrC,kBAAkB;EAClB,8BAA8B;EAC9B,2BAA2B;AAC7B;AACA;EACE,wCAAwC;EACxC,+BAA+B;EAC/B,4BAA4B;AAC9B;AACA;;EAEE,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,6BAA6B;AAC/B;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,qCAAqC;EACrC,cAAc;EACd,2CAA2C;EAC3C,YAAY;EACZ,qBAAqB,EAAE,qCAAqC;EAC5D,mBAAmB,EAAE,YAAY;EACjC,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,UAAU;AACZ;AACA;;;EAGE,eAAe;EACf,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,eAAe;AACjB;AACA;EACE,qCAAqC;EACrC,cAAc;EACd,qBAAqB,EAAE,qCAAqC;EAC5D,mBAAmB,EAAE,YAAY;EACjC,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB,EAAE,YAAY;EACjC,YAAY,EAAE,iBAAiB;AACjC;AACA,oBAAoB;AACpB;EACE,WAAW,EAAE,UAAU;AACzB;;AAEA;EACE,uBAAuB,EAAE,WAAW;AACtC;;AAEA;EACE,uBAAuB,EAAE,SAAS;EAClC,kBAAkB;EAClB,wCAAgC;EAAhC,gCAAgC;AAClC;;AAEA;EACE,8BAA8B,EAAE,UAAU;AAC5C;;AAEA;EACE,8BAA8B,EAAE,eAAe;AACjD;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,UAAU;EACV,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,YAAY;EACZ,UAAU;AACZ;AACA;EACE,eAAe;EACf,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,UAAU;EACV,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,UAAU;EACV,wCAAwC;EACxC,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,iBAAiB;AACnB;AACA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,UAAU;EACV,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,yBAAyB;EACzB,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,yBAAyB;AAC3B","sourcesContent":[".trans-container {\n  width: calc(100% - 40px);\n  height: calc(100% - 50px);\n  padding: 20px;\n  margin-top: 50px;\n}\n.trans-box {\n  height: calc(100% - 40px);\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-radius: 7px;\n}\n.original-text,\n.trans-text {\n  overflow-y: scroll;\n  height: calc(100% - 40px);\n  margin: 5px;\n  margin-top: 35px;\n  word-break: break-word;\n  overflow-wrap: break-word;\n}\n.original-text-box,\n.trans-text-box {\n  width: 100%;\n  height: 100%;\n  opacity: 1;\n  user-select: text;\n\n  padding: 5px;\n  box-sizing: border-box;\n  font-size: 15px;\n  line-height: 18px;\n  /* position: relative; */\n}\n.trans-lang-selector-container {\n  width: calc(100% - 40px);\n  height: 30px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 10px;\n  position: absolute;\n  top: 67px;\n}\n.trans-lang-box,\n.original-lang-box {\n  width: calc(50%);\n  height: 100%;\n  padding-left: 7px;\n  box-sizing: border-box;\n}\n.original-text-box {\n  /* margin-right: 10px; */\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  border-right: none;\n  border-bottom-left-radius: 7px;\n  border-top-left-radius: 7px;\n}\n.trans-text-box {\n  background-color: rgba(75, 75, 75, 0.05);\n  border-bottom-right-radius: 7px;\n  border-top-right-radius: 7px;\n}\n.trans-lang-selector,\n.original-lang-selector {\n  height: 30px;\n  opacity: 1;\n  box-sizing: border-box;\n  font-size: 15px;\n  line-height: 30px;\n  cursor: pointer;\n  border: none;\n  background-color: transparent;\n}\n.trans-lang-selector {\n  font-size: 15px;\n  line-height: 15px;\n}\n.trans-service-selector {\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  color: #f16464;\n  background-color: rgba(241, 100, 100, 0.05);\n  height: 34px;\n  display: inline-block; /* 修改：从 float: left 改为 inline-block */\n  vertical-align: top; /* 添加：对齐方式 */\n  padding-left: 10px;\n  padding-right: 10px;\n  border-radius: 8px;\n  margin-right: 10px;\n  text-align: center;\n  line-height: 34px;\n  cursor: pointer;\n  opacity: 1;\n}\n.trans-icon,\n.trans-google-icon,\n.trans-bing-icon {\n  font-size: 13px;\n  margin: 2px;\n  margin-right: 5px;\n}\n.trans-bing-icon {\n  font-size: 14px;\n}\n.trans-service-selector-inactive {\n  border: 1px solid rgba(0, 0, 0, 0.05);\n  color: #f16464;\n  display: inline-block; /* 修改：从 float: left 改为 inline-block */\n  vertical-align: top; /* 添加：对齐方式 */\n  height: 34px;\n  padding-left: 10px;\n  padding-right: 10px;\n  border-radius: 8px;\n  margin-right: 10px;\n  text-align: center;\n  line-height: 34px;\n  cursor: pointer;\n}\n.trans-service-selector-container {\n  position: absolute;\n  top: 20px;\n  width: 90%;\n  overflow-x: scroll;\n  overflow-y: hidden;\n  white-space: nowrap; /* 添加：防止换行 */\n  height: 42px; /* 添加：给容器一个固定高度 */\n}\n/* 滚动条样式 - 仅在悬停时显示 */\n.trans-service-selector-container::-webkit-scrollbar {\n  height: 4px; /* 滚动条高度 */\n}\n\n.trans-service-selector-container::-webkit-scrollbar-track {\n  background: transparent; /* 轨道背景透明 */\n}\n\n.trans-service-selector-container::-webkit-scrollbar-thumb {\n  background: transparent; /* 默认透明 */\n  border-radius: 2px;\n  transition: background 0.3s ease;\n}\n\n.trans-service-selector-container:hover::-webkit-scrollbar-thumb {\n  background: rgba(0, 0, 0, 0.2); /* 悬停时显示 */\n}\n\n.trans-service-selector-container::-webkit-scrollbar-thumb:hover {\n  background: rgba(0, 0, 0, 0.4); /* 滚动条本身悬停时加深 */\n}\n.trans-button-container {\n  position: absolute;\n  bottom: 8px;\n  right: 20px;\n  display: flex;\n  justify-content: space-between;\n}\n.trans-text-box {\n  left: 16px;\n  top: 16px;\n}\n.target-lang-container {\n  position: absolute;\n  width: calc(100% - 32px);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  bottom: 16px;\n  left: 16px;\n}\n.trans-add-icon {\n  font-size: 13px;\n  margin: 5px;\n}\n.trans-add-content-box {\n  width: 100%;\n  height: 150px;\n  opacity: 1;\n  font-size: 15px;\n  line-height: 18px;\n  padding: 10px;\n  margin-top: 10px;\n  margin-bottom: 10px;\n  box-sizing: border-box;\n  opacity: 1;\n  background-color: rgba(75, 75, 75, 0.05);\n  border-radius: 7px;\n  border: none;\n}\n.trans-add-content-box::placeholder {\n  font-weight: bold;\n}\n.trans-add-cancel {\n  min-width: 60px;\n  height: 30px;\n  opacity: 1;\n  padding-left: 5px;\n  padding-right: 5px;\n  font-size: 13px;\n  line-height: 30px;\n  opacity: 1;\n  text-align: center;\n  cursor: pointer;\n  border-radius: 5px;\n}\n.trans-add-confirm {\n  min-width: 64px;\n  height: 30px;\n  opacity: 1;\n  padding-left: 5px;\n  padding-right: 5px;\n  font-size: 13px;\n  line-height: 30px;\n  opacity: 1;\n  text-align: center;\n  cursor: pointer;\n  border-radius: 5px;\n  float: right;\n  background-color: #f16464;\n  color: white;\n  margin-left: 5px;\n}\n.trans-add-button-container {\n  display: flex;\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
